import { createTheme, ThemeProvider } from '@mui/material/styles';
import "./CSS/AboutPage.css"
import Navbar from './Navbar';
import CareersHeader from './Careers/CareersHeader';
import CareersIntro from './Careers/CareersIntro';
import Contact from './Contact';
import Footer from './Footer';


const theme = createTheme({
    palette: {
      primary: {
        main: "#ffffff",
      },
      secondary: {
        main: '#C5A47E',
      },
    },
    typography:{
      fontFamily:'Barlow'
    }
  });
  
export const Careers = () => {
  return (
   
     <ThemeProvider theme={theme}>
        <Navbar/>
       <CareersHeader/>
       <CareersIntro/>
       <Contact/>
       <Footer/>
     </ThemeProvider>
   
  );
}
